import { createBitmapIcon } from './bitmap-icon';

export const ActionsLeaf = createBitmapIcon(
    '/_n/images/fancy-landing/actions-leaf.svg'
);
